import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiDrawer = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiDrawer'];
  defaultProps?: ComponentsProps['MuiDrawer'];
  variants?: ComponentsVariants['MuiDrawer'];
};

export const MuiDrawer: MuiDrawer = {
  styleOverrides: {
    paper: {
      minWidth: 260,
    },
  },
};
